const scrollPos = () => window.pageYOffset;

const lock = (stickyElements = '') => {
  const { body } = document;
  const pos = scrollPos();

  if (stickyElements) {
    const sticky = document.querySelectorAll(stickyElements);
    if (sticky.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < sticky.length; i++) {
        sticky[i].style.position = 'relative';
        sticky[i].style.top = `${pos}px`;
      }
    }
  }

  body.style.position = 'fixed';
  body.style.top = `-${pos}px`;
};

const unlock = (stickyElements = '') => {
  const { body } = document;
  let pos = body.style.top;
  pos = parseFloat(pos) * -1;

  if (stickyElements) {
    const sticky = document.querySelectorAll(stickyElements);
    if (sticky.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < sticky.length; i++) {
        sticky[i].style.position = '';
        sticky[i].style.top = '';
      }
    }
  }

  body.style.position = '';
  body.style.top = '';

  window.scrollTo(0, pos);
};

const islocked = () => {
  const { body } = document;
  if (
    window
      .getComputedStyle(body)
      .getPropertyValue('position')
      .toLowerCase() === 'fixed'
  ) {
    return true;
  }
  return false;
};

const toggleLock = (stickyElements = '') => {
  if (islocked()) {
    unlock(stickyElements);
  } else {
    lock(stickyElements);
  }
};

export default { lock, unlock, islocked, toggleLock };
